import { NgModule } from '@angular/core';
import { GrocyRoutingModule } from './grocy-routing.module';

@NgModule({ imports: [GrocyRoutingModule] })
export class GrocyModule {}
